/**
 * Load the GTM web container via the server-side tagging host when configured.
 * Routes browser hits through metrics.lawfusion.ai so the server container can
 * forward to Reddit CAPI, Meta CAPI, and GA4.
 */
const GTM_WEB_CONTAINER_ID = "GTM-T96H8MPZ";

const gtmScriptHost = () => {
  const fromEnv = (process.env.REACT_APP_GTM_SERVER_URL || "").replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV === "production") {
    return "https://metrics.lawfusion.ai";
  }
  return "https://www.googletagmanager.com";
};

export const initGtm = () => {
  if (typeof window === "undefined" || window.__lawfusionGtmLoaded) return;
  window.__lawfusionGtmLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const host = gtmScriptHost();
  const script = document.createElement("script");
  script.async = true;
  script.src = `${host}/gtm.js?id=${GTM_WEB_CONTAINER_ID}`;
  const first = document.getElementsByTagName("script")[0];
  if (first?.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }
};
